import React, { forwardRef, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { HiMenu, HiX } from "react-icons/hi";
import M2TLogo from "../common/M2TLogo";

const links = [
  { label: "About Us", path: "/about-us" },
  //{ label: "Team", path: "/team" },
  // { label: "Careers", path: "/careers" },
  { label: "Solutions", path: "/solutions" },
  { label: "Founders Journey", path: "/founderjourney" },
  { label: "Contact Us", path: "/contact" },
];

const CompanyHeader = forwardRef(function CompanyHeader({ activePage }, ref) {
  const navigate = useNavigate();
  const location = useLocation();
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <header
      ref={ref}
      className="fixed left-0 top-0 z-50 w-full border-b border-gray-200 bg-white shadow-sm"
    >
      <div className="mx-auto flex max-w-6xl items-center justify-between px-4 py-3 md:py-4">
        {/* Logo & Title */}
        <div
          className="flex cursor-pointer items-center gap-2"
          onClick={() => navigate("/")}
          aria-label="Go to homepage"
        >
          {/* Logo scales with screen */}
          <M2TLogo className="h-[1.75rem] sm:h-[2.4rem] md:h-[2.8rem]" />
        </div>
        {/* Desktop Nav */}
        <nav className="hidden items-center space-x-6 text-base font-medium md:flex">
          {links.map((link) => (
            <button
              key={link.path}
              onClick={() => navigate(link.path)}
              className={`px-2 py-1 ${
                location.pathname === link.path
                  ? "border-b-2 border-purple-500 font-bold text-purple-600"
                  : "text-gray-700 transition-colors hover:text-purple-600"
              } `}
            >
              {link.label}
            </button>
          ))}
        </nav>
        {/* Mobile Hamburger */}
        <div className="md:hidden">
          <button
            onClick={() => setMenuOpen(!menuOpen)}
            aria-label={menuOpen ? "Close menu" : "Open menu"}
            className="text-3xl text-gray-900"
          >
            {menuOpen ? <HiX /> : <HiMenu />}
          </button>
        </div>
      </div>
      {/* Mobile Dropdown */}
      {menuOpen && (
        <div className="absolute left-0 top-full z-50 w-full border-t border-gray-200 bg-white shadow-lg md:hidden">
          <nav className="flex flex-col items-start space-y-2 px-6 py-4">
            {links.map((link) => (
              <button
                key={link.path}
                onClick={() => {
                  navigate(link.path);
                  setMenuOpen(false);
                }}
                className={`w-full py-2 text-left ${
                  location.pathname === link.path
                    ? "font-bold text-purple-600"
                    : "text-gray-700 hover:text-purple-600"
                } `}
              >
                {link.label}
              </button>
            ))}
          </nav>
        </div>
      )}
    </header>
  );
});

export default CompanyHeader;
